import { GroupDetails, Groups } from "../Components/index.js";

export default [
    {
        path: "/reports/account/group",
        component: Groups,
        name: "report.account.inventory.group",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/reports/account/group/:id",
        component: GroupDetails,
        name: "report.account.inventory.details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/reports/account/group-item/:id",
        component: Groups,
        name: "report.account.inventory.group.item",
        meta: {
            requiresAuth: true,
        },
    },
];
